import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import {
  getMInvoices as getMInvoicesApi,
  addNewMInvoice as addNewMInvoiceApi,
  updateMInvoice as updateMInvoiceApi,
  deleteMInvoice as deleteMInvoiceApi,
  getMInvoiceByNumber as getMInvoiceByNumberApi,
} from "../../helpers/realbackend_helper";

export const getMInvoices = createAsyncThunk(
  "minvoice/getMInvoices",
  async () => {
    try {
      const response = await getMInvoicesApi();
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const getMInvoiceByNumber = createAsyncThunk(
  "minvoice/getMInvoiceByNumber",
  async (minvoice) => {
    try {
      const response = await getMInvoiceByNumberApi(minvoice);
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const addNewMInvoice = createAsyncThunk(
  "minvoice/addNewMInvoice",
  async (minvoice) => {
    try {
      const response = addNewMInvoiceApi(minvoice);
      toast.success("Нэхэмжлэх амжилттай бүртгэлээ", {
        autoClose: 3000,
      });
      return response;
    } catch (error) {
      toast.error("Нэхэмжлэх бүртгэхэд алдаа гарлаа!", {
        autoClose: 3000,
      });
      return error;
    }
  }
);

export const updateMInvoice = createAsyncThunk(
  "minvoice/updateMInvoice",
  async (minvoice) => {
    try {
      const response = updateMInvoiceApi(minvoice);
      toast.success("Нэхэмжлэх амжилттай засварлалаа", {
        autoClose: 3000,
      });
      return response;
    } catch (error) {
      toast.error("Нэхэмжлэх засварлахад алдаа гарлаа!", {
        autoClose: 3000,
      });
      return error;
    }
  }
);

export const deleteMInvoice = createAsyncThunk(
  "minvoice/deleteMInvoice",
  async (id, { rejectWithValue }) => {
    try {
      await deleteMInvoiceApi(id);

      toast.success("Нэхэмжлэх амжилттай устгалаа", {
        autoClose: 3000,
      });

      return { id };
    } catch (error) {
      toast.error("Нэхэмжлэх устгахад алдаа гарлаа!", {
        autoClose: 3000,
      });

      return rejectWithValue({
        error: error.response?.data?.message || error.message,
      });
    }
  }
);
